export const pinData = [
		{
			lat: '8.393075',
			lng: '124.5976',
			name: 'Philippines 1',
			img_href: '0',
		},
		{
			lat: '8.392669',
			lng: '124.5977',
			name: 'Philippines 2',
			img_href: '0',
		},
		{
			lat: '8.392888',
			lng: '124.5975',
			name: 'Philippines 3',
			img_href: '0',
		},
		{
			lat: '8.393086',
			lng: '124.5966',
			name: 'Philippines 4',
			img_href: '0',
		},
		{
			lat: '8.393068',
			lng: '124.5963',
			name: 'Philippines 5',
			img_href: '0',
		},
		{
			lat: '8.400914',
			lng: '124.5967',
			name: 'Philippines 6',
			img_href: '0',
		},
		{
			lat: '8.399773',
			lng: '124.5961',
			name: 'Philippines 7',
			img_href: '0',
		},
		{
			lat: '8.403428',
			lng: '124.5993',
			name: 'Philippines 8',
			img_href: '0',
		},
		{
			lat: '8.403463',
			lng: '124.5993',
			name: 'Philippines 9',
			img_href: '0',
		},
		{
			lat: '8.403313',
			lng: '124.5994',
			name: 'Philippines 10',
			img_href: '0',
		},
		{
			lat: '8.404541',
			lng: '124.5999',
			name: 'Philippines 11',
			img_href: '0',
		},
		{
			lat: '8.401908',
			lng: '124.5982',
			name: 'Philippines 12',
			img_href: '0',
		},
		{
			lat: '8.400824',
			lng: '124.5965',
			name: 'Philippines 13',
			img_href: '0',
		},
		{
			lat: '8.402668',
			lng: '124.5946',
			name: 'Philippines 14',
			img_href: '0',
		},
		{
			lat: '8.40239',
			lng: '124.5734',
			name: 'Philippines 15',
			img_href: '0',
		},
		{
			lat: '8.402404',
			lng: '124.572',
			name: 'Philippines 16',
			img_href: '0',
		},
		{
			lat: '8.402276',
			lng: '124.5722',
			name: 'Philippines 17',
			img_href: '0',
		},
		{
			lat: '8.402661',
			lng: '124.5714',
			name: 'Philippines 18',
			img_href: '0',
		},
		{
			lat: '8.383973',
			lng: '124.6095',
			name: 'Philippines 19',
			img_href: '0',
		},
		{
			lat: '8.522593',
			lng: '124.5704',
			name: 'Philippines 20',
			img_href: '0',
		},
		{
			lat: '8.522643',
			lng: '124.5704',
			name: 'Philippines 21',
			img_href: '0',
		},
		{
			lat: '8.522649',
			lng: '124.5703',
			name: 'Philippines 22',
			img_href: '0',
		},
		{
			lat: '8.522589',
			lng: '124.5703',
			name: 'Philippines 23',
			img_href: '0',
		},
		{
			lat: '8.52258',
			lng: '124.5703',
			name: 'Philippines 24',
			img_href: '0',
		},
		{
			lat: '8.493672',
			lng: '124.6291',
			name: 'Philippines 32',
			img_href: '0',
		},
		{
			lat: '8.65484',
			lng: '124.9057',
			name: 'Philippines 33',
			img_href: '0',
		},
		{
			lat: '8.65485',
			lng: '124.9057',
			name: 'Philippines 35',
			img_href: '0',
		},
		{
			lat: '8.65485',
			lng: '124.9057',
			name: 'Philippines 36',
			img_href: '0',
		},
		{
			lat: '8.654856',
			lng: '124.9057',
			name: 'Philippines 37',
			img_href: '0',
		},
		{
			lat: '8.654867',
			lng: '124.9056',
			name: 'Philippines 38',
			img_href: '0',
		},
		{
			lat: '8.655002',
			lng: '124.9055',
			name: 'Philippines 39',
			img_href: '0',
		},
		{
			lat: '8.654751',
			lng: '124.9054',
			name: 'Philippines 40',
			img_href: '0',
		},
		{
			lat: '8.654735',
			lng: '124.9055',
			name: 'Philippines 41',
			img_href: '0',
		},
		{
			lat: '8.654956',
			lng: '124.9056',
			name: 'Philippines 42',
			img_href: '0',
		},
		{
			lat: '8.654976',
			lng: '124.9055',
			name: 'Philippines 43',
			img_href: '0',
		},
		{
			lat: '8.654976',
			lng: '124.9055',
			name: 'Philippines 44',
			img_href: '0',
		},
		{
			lat: '8.654976',
			lng: '124.9055',
			name: 'Philippines 45',
			img_href: '0',
		},
		{
			lat: '8.654978',
			lng: '124.9055',
			name: 'Philippines 46',
			img_href: '0',
		},
		{
			lat: '8.654979',
			lng: '124.9055',
			name: 'Philippines 47',
			img_href: '0',
		},
		{
			lat: '8.654979',
			lng: '124.9055',
			name: 'Philippines 48',
			img_href: '0',
		},
		{
			lat: '8.654979',
			lng: '124.9055',
			name: 'Philippines 49',
			img_href: '0',
		},
		{
			lat: '8.654979',
			lng: '124.9055',
			name: 'Philippines 50',
			img_href: '0',
		},
		{
			lat: '8.653966',
			lng: '124.9057',
			name: 'Philippines 51',
			img_href: '0',
		},
		{
			lat: '8.653805',
			lng: '124.9056',
			name: 'Philippines 52',
			img_href: '0',
		},
		{
			lat: '8.653806',
			lng: '124.9056',
			name: 'Philippines 53',
			img_href: '0',
		},
		{
			lat: '8.653807',
			lng: '124.9058',
			name: 'Philippines 54',
			img_href: '0',
		},
		{
			lat: '8.653806',
			lng: '124.9058',
			name: 'Philippines 55',
			img_href: '0',
		},
		{
			lat: '8.653828',
			lng: '124.9058',
			name: 'Philippines 56',
			img_href: '0',
		},
		{
			lat: '8.653828',
			lng: '124.9058',
			name: 'Philippines 57',
			img_href: '0',
		},
		{
			lat: '8.653828',
			lng: '124.9058',
			name: 'Philippines 58',
			img_href: '0',
		},
		{
			lat: '8.65388',
			lng: '124.906',
			name: 'Philippines 59',
			img_href: '0',
		},
		{
			lat: '8.65388',
			lng: '124.906',
			name: 'Philippines 60',
			img_href: '0',
		},
		{
			lat: '8.653983',
			lng: '124.906',
			name: 'Philippines 61',
			img_href: '0',
		},
		{
			lat: '8.653983',
			lng: '124.906',
			name: 'Philippines 62',
			img_href: '0',
		},
		{
			lat: '8.65396',
			lng: '124.9057',
			name: 'Philippines 63',
			img_href: '0',
		},
		{
			lat: '8.65396',
			lng: '124.9057',
			name: 'Philippines 64',
			img_href: '0',
		},
		{
			lat: '8.65396',
			lng: '124.9057',
			name: 'Philippines 65',
			img_href: '0',
		},
		{
			lat: '8.653994',
			lng: '124.9057',
			name: 'Philippines 66',
			img_href: '0',
		},
		{
			lat: '8.650002',
			lng: '124.9126',
			name: 'Philippines 71',
			img_href: '0',
		},
		{
			lat: '8.650002',
			lng: '124.9126',
			name: 'Philippines 72',
			img_href: '0',
		},
		{
			lat: '8.649814',
			lng: '124.9125',
			name: 'Philippines 73',
			img_href: '0',
		},
		{
			lat: '8.649815',
			lng: '124.9125',
			name: 'Philippines 74',
			img_href: '0',
		},
		{
			lat: '8.649815',
			lng: '124.9125',
			name: 'Philippines 75',
			img_href: '0',
		},
		{
			lat: '8.649638',
			lng: '124.9129',
			name: 'Philippines 76',
			img_href: '0',
		},
		{
			lat: '8.649639',
			lng: '124.9129',
			name: 'Philippines 77',
			img_href: '0',
		},
		{
			lat: '8.649872',
			lng: '124.913',
			name: 'Philippines 78',
			img_href: '0',
		},
		{
			lat: '8.649872',
			lng: '124.913',
			name: 'Philippines 79',
			img_href: '0',
		},
		{
			lat: '8.649987',
			lng: '124.9126',
			name: 'Philippines 80',
			img_href: '0',
		},
		{
			lat: '8.649987',
			lng: '124.9126',
			name: 'Philippines 81',
			img_href: '0',
		},
		{
			lat: '8.649987',
			lng: '124.9126',
			name: 'Philippines 82',
			img_href: '0',
		},
		{
			lat: '8.65141',
			lng: '124.9132',
			name: 'Philippines 83',
			img_href: '0',
		},
		{
			lat: '8.65141',
			lng: '124.9132',
			name: 'Philippines 84',
			img_href: '0',
		},
		{
			lat: '8.651468',
			lng: '124.9132',
			name: 'Philippines 85',
			img_href: '0',
		},
		{
			lat: '8.65147',
			lng: '124.9132',
			name: 'Philippines 86',
			img_href: '0',
		},
		{
			lat: '8.651443',
			lng: '124.9132',
			name: 'Philippines 87',
			img_href: '0',
		},
		{
			lat: '8.651443',
			lng: '124.9132',
			name: 'Philippines 88',
			img_href: '0',
		},
		{
			lat: '8.651357',
			lng: '124.9132',
			name: 'Philippines 89',
			img_href: '0',
		},
		{
			lat: '8.651358',
			lng: '124.9132',
			name: 'Philippines 90',
			img_href: '0',
		},
		{
			lat: '8.651329',
			lng: '124.9131',
			name: 'Philippines 91',
			img_href: '0',
		},
		{
			lat: '8.65133',
			lng: '124.9131',
			name: 'Philippines 92',
			img_href: '0',
		},
		{
			lat: '8.651347',
			lng: '124.913',
			name: 'Philippines 93',
			img_href: '0',
		},
		{
			lat: '8.651348',
			lng: '124.913',
			name: 'Philippines 94',
			img_href: '0',
		},
		{
			lat: '8.651438',
			lng: '124.913',
			name: 'Philippines 95',
			img_href: '0',
		},
		{
			lat: '8.651438',
			lng: '124.913',
			name: 'Philippines 96',
			img_href: '0',
		},
		{
			lat: '8.651397',
			lng: '124.9131',
			name: 'Philippines 97',
			img_href: '0',
		},
		{
			lat: '8.651397',
			lng: '124.9131',
			name: 'Philippines 98',
			img_href: '0',
		},
		{
			lat: '8.651397',
			lng: '124.9131',
			name: 'Philippines 99',
			img_href: '0',
		},
		{
			lat: '8.651401',
			lng: '124.9133',
			name: 'Philippines 100',
			img_href: '0',
		},
		{
			lat: '8.651401',
			lng: '124.9133',
			name: 'Philippines 101',
			img_href: '0',
		},
		{
			lat: '8.651401',
			lng: '124.9133',
			name: 'Philippines 102',
			img_href: '0',
		},
		{
			lat: '8.651401',
			lng: '124.9133',
			name: 'Philippines 103',
			img_href: '0',
		},
		{
			lat: '8.479748',
			lng: '124.637',
			name: 'Philippines bee',
			img_href: '0',
		},
		{
			lat: '8.654848',
			lng: '124.9057',
			name: 'Philippines C',
			img_href: '0',
		},
		{
			lat: '8.420664',
			lng: '124.6289',
			name: 'Philippines H1',
			img_href: '0',
		},
		{
			lat: '8.421979',
			lng: '124.6296',
			name: 'Philippines H2',
			img_href: '0',
		},
		{
			lat: '8.421495',
			lng: '124.6304',
			name: 'Philippines H3',
			img_href: '0',
		},
		{
			lat: '8.420313',
			lng: '124.6299',
			name: 'Philippines H4',
			img_href: '0',
		},
		{
			lat: '8.4214',
			lng: '124.6292',
			name: 'Philippines H5',
			img_href: '0',
		},
		{
			lat: '8.420792',
			lng: '124.63',
			name: 'Philippines H6',
			img_href: '0',
		},
		{
			lat: '8.297367',
			lng: '124.5983',
			name: 'Langaon_1.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_1.0.jpg',
		},
		{
			lat: '8.295817',
			lng: '124.5997',
			name: 'Langaon_15.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_15.0.jpg',
		},
		{
			lat: '8.300983',
			lng: '124.5976',
			name: 'Langaon_3.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_3.0.jpg',
		},
		{
			lat: '8.299267',
			lng: '124.5983',
			name: 'Langaon_23.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_23.0.jpg',
		},
		{
			lat: '8.29725',
			lng: '124.5987',
			name: 'Langaon_17.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_17.0.jpg',
		},
		{
			lat: '8.29955',
			lng: '124.5976',
			name: 'Langaon_18.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_18.0.jpg',
		},
		{
			lat: '8.3007',
			lng: '124.5984',
			name: 'Langaon_4.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_4.0.jpg',
		},
		{
			lat: '8.293633',
			lng: '124.5995',
			name: 'Langaon_2.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_2.0.jpg',
		},
		{
			lat: '8.295883',
			lng: '124.5987',
			name: 'Langaon_19.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_19.0.jpg',
		},
		{
			lat: '8.295833',
			lng: '124.5986',
			name: 'Langaon_20.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_20.0.jpg',
		},
		{
			lat: '8.296217',
			lng: '124.5987',
			name: 'Langaon_21.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_21.0.jpg',
		},
		{
			lat: '8.295817',
			lng: '124.5986',
			name: 'Langaon_22.0',
			img_href: '0',
		},
		{
			lat: '8.297267',
			lng: '124.5987',
			name: 'Langaon_24.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_24.0.jpg',
		},
		{
			lat: '8.2996',
			lng: '124.5983',
			name: 'Langaon_25.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_25.0.jpg',
		},
		{
			lat: '8.295917',
			lng: '124.5987',
			name: 'Langaon_26.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_26.0.jpg',
		},
		{
			lat: '8.296167',
			lng: '124.5991',
			name: 'Langaon_27.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_27.0.jpg',
		},
		{
			lat: '8.299667',
			lng: '124.5981',
			name: 'Langaon_28.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_28.0.jpg',
		},
		{
			lat: '8.3003',
			lng: '124.5983',
			name: 'Langaon_29.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_29.0.jpg',
		},
		{
			lat: '8.299017',
			lng: '124.606',
			name: 'Langaon_30.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_30.0.jpg',
		},
		{
			lat: '8.299667',
			lng: '124.5981',
			name: 'Langaon_31.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_31.0.jpg',
		},
		{
			lat: '8.297533',
			lng: '124.5983',
			name: 'Langaon_32.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_32.0.jpg',
		},
		{
			lat: '8.296133',
			lng: '124.5988',
			name: 'Langaon_33.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_33.0.jpg',
		},
		{
			lat: '8.2998',
			lng: '124.5982',
			name: 'Langaon_34.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_34.0.jpg',
		},
		{
			lat: '8.300217',
			lng: '124.5998',
			name: 'Langaon_35.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_35.0.jpg',
		},
		{
			lat: '8.29615',
			lng: '124.5988',
			name: 'Langaon_36.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon_36.0.jpg',
		},
		{
			lat: '8.536535',
			lng: '124.3129',
			name: 'Bobutan_5.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Bobutan_5.0.jpg',
		},
		{
			lat: '8.536327',
			lng: '124.3129',
			name: 'Bobutan_6.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Bobutan_6.0.jpg',
		},
		{
			lat: '8.53656',
			lng: '124.3129',
			name: 'Bobutan_7.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Bobutan_7.0.jpg',
		},
		{
			lat: '8.53646',
			lng: '124.313',
			name: 'Bobutan_8.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Bobutan_8.0.jpg',
		},
		{
			lat: '8.536451',
			lng: '124.313',
			name: 'Bobutan_9.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Bobutan_9.0.jpg',
		},
		{
			lat: '8.536435',
			lng: '124.3129',
			name: 'Bobutan_10.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Bobutan_10.0.jpg',
		},
		{
			lat: '8.536434',
			lng: '124.3129',
			name: 'Bobutan_11.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Bobutan_11.0.jpg',
		},
		{
			lat: '8.53638',
			lng: '124.3129',
			name: 'Bobutan_12.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Bobutan_12.0.jpg',
		},
		{
			lat: '8.536397',
			lng: '124.3129',
			name: 'Bobutan_13.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Bobutan_13.0.jpg',
		},
		{
			lat: '8.536327',
			lng: '124.3129',
			name: 'Bobutan_14.0',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Bobutan_14.0.jpg',
		},
		{
			lat: '11.51475',
			lng: '79.61503',
			name: 'Kumudimoolai 1',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+1.jpg',
		},
		{
			lat: '11.51557',
			lng: '79.61575',
			name: 'Kumudimoolai 2',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+2.jpg',
		},
		{
			lat: '11.51482',
			lng: '79.61543',
			name: 'Kumudimoolai 3',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+3.jpg',
		},
		{
			lat: '11.51575',
			lng: '79.617',
			name: 'Kumudimoolai 4',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+4.jpg',
		},
		{
			lat: '11.51515',
			lng: '79.61743',
			name: 'Kumudimoolai 5',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+5.jpg',
		},
		{
			lat: '11.51527',
			lng: '79.61783',
			name: 'Kumudimoolai 6',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+6.jpg',
		},
		{
			lat: '11.5145',
			lng: '79.6161',
			name: 'Kumudimoolai 7',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+7.jpg',
		},
		{
			lat: '11.51468',
			lng: '79.6174',
			name: 'Kumudimoolai 8',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+8.jpg',
		},
		{
			lat: '11.5152',
			lng: '79.61573',
			name: 'Kumudimoolai 9',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+9.jpg',
		},
		{
			lat: '11.51472',
			lng: '79.61548',
			name: 'Kumudimoolai 10',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+10.jpg',
		},
		{
			lat: '12.37335',
			lng: '-1.4012',
			name: 'Saaba 1',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Saaba+1.jpg',
		},
		{
			lat: '12.37297',
			lng: '-1.4011',
			name: 'Saaba 2',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Saaba+2.jpg',
		},
		{
			lat: '10.64737',
			lng: '-4.75525',
			name: 'Banfora 1',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Banfora+1.jpg',
		},
		{
			lat: '10.64728',
			lng: '-4.75598',
			name: 'Banfora 2',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Banfora+2.jpg',
		},
		{
			lat: '10.65915',
			lng: '-4.85',
			name: 'Tengrela 1',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tengrela+1.jpg',
		},
		{
			lat: '10.65645',
			lng: '-4.86313',
			name: 'Tengrela 2',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tengrela+2.jpg',
		},
		{
			lat: '10.65727',
			lng: '-4.86797',
			name: 'Tengrela 3',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tengrela+3.jpg',
		},
		{
			lat: '10.65602',
			lng: '-4.87402',
			name: 'Tengrela 4',
			img_href: '0',
		},
		{
			lat: '10.65708',
			lng: '-4.87858',
			name: 'Tengrela 5',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tengrela+5.jpg',
		},
		{
			lat: '10.65565',
			lng: '-4.82755',
			name: 'Tengrela 6',
			img_href: '0',
		},
		{
			lat: '10.65567',
			lng: '-4.8275',
			name: 'Tengrela 7',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tengrela+7.jpg',
		},
		{
			lat: '10.65177',
			lng: '-4.8273',
			name: 'Tengrela 8',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tengrela+8.jpg',
		},
		{
			lat: '10.6533',
			lng: '-4.82437',
			name: 'Tengrela 9',
			img_href: '0',
		},
		{
			lat: '10.65372',
			lng: '-4.82423',
			name: 'Tengrela 10',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tengrela+10.jpg',
		},
		{
			lat: '10.65373',
			lng: '-4.82382',
			name: 'Tengrela 11',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tengrela+11.jpg',
		},
		{
			lat: '10.6527',
			lng: '-4.82373',
			name: 'Tengrela 12',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tengrela+12.jpg',
		},
		{
			lat: '10.65738',
			lng: '-4.82647',
			name: 'Tengrela 13',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tengrela+13.jpg',
		},
		{
			lat: '10.65932',
			lng: '-4.82665',
			name: 'Tengrela 14',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tengrela+14.jpg',
		},
		{
			lat: '10.64825',
			lng: '-4.80752',
			name: 'Tengrela 15',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tengrela+15.jpg',
		},
		{
			lat: '10.64852',
			lng: '-4.808',
			name: 'Tengrela 16',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tengrela+16.jpg',
		},
		{
			lat: '0',
			lng: '0',
			name: 'Ouagadougou 1',
			img_href: '0',
		},
		{
			lat: '0',
			lng: '0',
			name: 'Saaba 3',
			img_href: '0',
		},
		{
			lat: '0',
			lng: '0',
			name: 'Saaba 4',
			img_href: '0',
		},
		{
			lat: '0',
			lng: '0',
			name: 'Saaba 5',
			img_href: '0',
		},
		{
			lat: '0',
			lng: '0',
			name: 'Saaba 6',
			img_href: '0',
		},
		{
			lat: '0',
			lng: '0',
			name: 'Saaba 7',
			img_href: '0',
		},
		{
			lat: '0',
			lng: '0',
			name: 'Tondtenga 1',
			img_href: '0',
		},
		{
			lat: '11.5135',
			lng: '79.62355',
			name: 'Kumudimoolai 11',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+11.jpg',
		},
		{
			lat: '11.51352',
			lng: '79.62347',
			name: 'Kumudimoolai 12',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+12.jpg',
		},
		{
			lat: '11.5135',
			lng: '79.62333',
			name: 'Kumudimoolai 13',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+13.jpg',
		},
		{
			lat: '11.51348',
			lng: '79.6232',
			name: 'Kumudimoolai 14',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+14.jpg',
		},
		{
			lat: '11.51345',
			lng: '79.62292',
			name: 'Kumudimoolai 15',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+15.jpg',
		},
		{
			lat: '11.5136',
			lng: '79.62283',
			name: 'Kumudimoolai 16',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+16.jpg',
		},
		{
			lat: '11.5135',
			lng: '79.62277',
			name: 'Kumudimoolai 17',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+17.jpg',
		},
		{
			lat: '11.51327',
			lng: '79.62338',
			name: 'Kumudimoolai 18',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+18.jpg',
		},
		{
			lat: '11.51283',
			lng: '79.6232',
			name: 'Kumudimoolai 19',
			img_href: '0',
		},
		{
			lat: '11.51273',
			lng: '79.62305',
			name: 'Kumudimoolai 20',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+20.jpg',
		},
		{
			lat: '11.51363',
			lng: '79.6233',
			name: 'Kumudimoolai 21',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+21.jpg',
		},
		{
			lat: '11.51393',
			lng: '79.62297',
			name: 'Kumudimoolai 22',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+22.jpg',
		},
		{
			lat: '11.51365',
			lng: '79.62285',
			name: 'Kumudimoolai 23',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+23.jpg',
		},
		{
			lat: '11.51365',
			lng: '79.62287',
			name: 'Kumudimoolai 24',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+24.jpg',
		},
		{
			lat: '11.51362',
			lng: '79.62278',
			name: 'Kumudimoolai 25',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+25.jpg',
		},
		{
			lat: '11.51383',
			lng: '79.62243',
			name: 'Kumudimoolai 26',
			img_href: '0',
		},
		{
			lat: '11.51422',
			lng: '79.6225',
			name: 'Kumudimoolai 27',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+27.jpg',
		},
		{
			lat: '11.51438',
			lng: '79.62252',
			name: 'Kumudimoolai 28',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+28.jpg',
		},
		{
			lat: '11.5142',
			lng: '79.6224',
			name: 'Kumudimoolai 29',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+29.jpg',
		},
		{
			lat: '11.5146',
			lng: '79.62257',
			name: 'Kumudimoolai 30',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+30.jpg',
		},
		{
			lat: '11.51407',
			lng: '79.62245',
			name: 'Kumudimoolai 31',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+31.jpg',
		},
		{
			lat: '11.51395',
			lng: '79.62233',
			name: 'Kumudimoolai 32',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+32.jpg',
		},
		{
			lat: '11.514',
			lng: '79.62282',
			name: 'Kumudimoolai 33',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+33.jpg',
		},
		{
			lat: '11.51367',
			lng: '79.62303',
			name: 'Kumudimoolai 34',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+34.jpg',
		},
		{
			lat: '11.4753',
			lng: '79.58257',
			name: 'Kumudimoolai 35',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+35.jpg',
		},
		{
			lat: '11.51473',
			lng: '79.61545',
			name: 'Kumudimoolai 36',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+36.jpg',
		},
		{
			lat: '11.51538',
			lng: '79.61602',
			name: 'Kumudimoolai 37',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+37.jpg',
		},
		{
			lat: '11.5148',
			lng: '79.61535',
			name: 'Kumudimoolai 38',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+38.jpg',
		},
		{
			lat: '11.5148',
			lng: '79.61482',
			name: 'Kumudimoolai 39',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+39.jpg',
		},
		{
			lat: '11.51515',
			lng: '79.6148',
			name: 'Kumudimoolai 40',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+40.jpg',
		},
		{
			lat: '11.51453',
			lng: '79.61492',
			name: 'Kumudimoolai 41',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+41.jpg',
		},
		{
			lat: '11.5144',
			lng: '79.61353',
			name: 'Kumudimoolai 42',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+42.jpg',
		},
		{
			lat: '11.51427',
			lng: '79.61203',
			name: 'Kumudimoolai 43',
			img_href: '0',
		},
		{
			lat: '11.51422',
			lng: '79.61172',
			name: 'Kumudimoolai 44',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+44.jpg',
		},
		{
			lat: '11.51452',
			lng: '79.61575',
			name: 'Kumudimoolai 45',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+45.jpg',
		},
		{
			lat: '11.51432',
			lng: '79.61617',
			name: 'Kumudimoolai 46',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+46.jpg',
		},
		{
			lat: '11.51472',
			lng: '79.61712',
			name: 'Kumudimoolai 47',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+47.jpg',
		},
		{
			lat: '11.5147',
			lng: '79.61603',
			name: 'Kumudimoolai 48',
			img_href: '0',
		},
		{
			lat: '11.5147',
			lng: '79.61603',
			name: 'Kumudimoolai 49',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+49.jpg',
		},
		{
			lat: '11.51343',
			lng: '79.62053',
			name: 'Kumudimoolai 50',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+50.jpg',
		},
		{
			lat: '11.51342',
			lng: '79.6205',
			name: 'Kumudimoolai 51',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+51.jpg',
		},
		{
			lat: '11.51302',
			lng: '79.621',
			name: 'Kumudimoolai 52',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+52.jpg',
		},
		{
			lat: '11.51382',
			lng: '79.6214',
			name: 'Kumudimoolai 53',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+53.jpg',
		},
		{
			lat: '11.51382',
			lng: '79.62123',
			name: 'Kumudimoolai 54',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+54.jpg',
		},
		{
			lat: '11.51408',
			lng: '79.62127',
			name: 'Kumudimoolai 55',
			img_href: '0',
		},
		{
			lat: '11.51393',
			lng: '79.62118',
			name: 'Kumudimoolai 56',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+56.jpg',
		},
		{
			lat: '11.51405',
			lng: '79.62075',
			name: 'Kumudimoolai 57',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+57.jpg',
		},
		{
			lat: '11.5141',
			lng: '79.62193',
			name: 'Kumudimoolai 58',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+58.jpg',
		},
		{
			lat: '11.51452',
			lng: '79.62208',
			name: 'Kumudimoolai 59',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+59.jpg',
		},
		{
			lat: '11.5136',
			lng: '79.61625',
			name: 'Kumudimoolai 60',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Kumudimoolai+60.jpg',
		},
		{
			lat: '-16.56525',
			lng: '-68.173639',
			name: 'ACH-19',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-19.png',
		},
		{
			lat: '-16.56525',
			lng: '-68.173639',
			name: 'ACH-20',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-20.png',
		},
		{
			lat: '-16.564306',
			lng: '-68.174167',
			name: 'ACH-21',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-21.png',
		},
		{
			lat: '-16.566028',
			lng: '-68.174972',
			name: 'ACH-22',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-22.png',
		},
		{
			lat: '-16.567',
			lng: '-68.175278',
			name: 'ACH-23',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-23.png',
		},
		{
			lat: '-16.56775',
			lng: '-68.176639',
			name: 'ACH-24',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-24.png',
		},
		{
			lat: '-16.567917',
			lng: '-68.176694',
			name: 'ACH-25',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-25.png',
		},
		{
			lat: '-16.567194',
			lng: '-68.171972',
			name: 'ACH-26',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-26.png',
		},
		{
			lat: '-16.567639',
			lng: '-68.172611',
			name: 'ACH-27',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-27.png',
		},
		{
			lat: '-16.567472',
			lng: '-68.173167',
			name: 'ACH-28',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-28.png',
		},
		{
			lat: '-16.568583',
			lng: '-68.176389',
			name: 'ACH-29',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-29.png',
		},
		{
			lat: '-16.568583',
			lng: '-68.176389',
			name: 'ACH-30',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-30.png',
		},
		{
			lat: '-16.510194',
			lng: '-68.129528',
			name: 'ACH-31',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-31.png',
		},
		{
			lat: '-16.571278',
			lng: '-68.178222',
			name: 'ACH-32',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-32.png',
		},
		{
			lat: '-16.574528',
			lng: '-68.178806',
			name: 'ACH-33',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-33.png',
		},
		{
			lat: '-16.577167',
			lng: '-68.176389',
			name: 'ACH-34',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-34.png',
		},
		{
			lat: '-16.578139',
			lng: '-68.174306',
			name: 'ACH-35',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-35.png',
		},
		{
			lat: '-16.585694',
			lng: '-68.134944',
			name: 'ACH-36',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/ACH-36.png',
		},
		{
			lat: '42.24715',
			lng: '42.244335',
			name: 'Sepieti 1',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Sepieti+1.png',
		},
		{
			lat: '42.276897',
			lng: '42.243748',
			name: 'Sepieti 2',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Sepieti+2.png',
		},
		{
			lat: '42.286053',
			lng: '42.243382',
			name: 'Sepieti 3',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Sepieti+3.png',
		},
		{
			lat: '42.286026',
			lng: '42.242867',
			name: 'Sepieti 4',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Sepieti+4.png',
		},
		{
			lat: '42.280205',
			lng: '42.236137',
			name: 'Sepieti 5',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Sepieti+5.png',
		},
		{
			lat: '42.279461',
			lng: '42.235668',
			name: 'Sepieti 6',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Sepieti+6.png',
		},
		{
			lat: '42.27956',
			lng: '42.235405',
			name: 'Sepieti 7',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Sepieti+7.png',
		},
		{
			lat: '42.4879325',
			lng: '78.3865372',
			name: 'Issyk-Kul-1',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Issyk-Kul-1.jpg',
		},
		{
			lat: '8.2681',
			lng: '124.613233',
			name: 'Purok 1',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+1.JPG',
		},
		{
			lat: '8.25995',
			lng: '124.616533',
			name: 'Purok 2',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+2.JPG',
		},
		{
			lat: '8.259667',
			lng: '124.616533',
			name: 'Purok 3',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+3.JPG',
		},
		{
			lat: '8.259633',
			lng: '124.6166 ',
			name: 'Purok 4',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+4.JPG',
		},
		{
			lat: '8.460967',
			lng: '124.625967',
			name: 'Purok 5',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+5.JPG',
		},
		{
			lat: '8.270383',
			lng: '124.604617',
			name: 'Purok 6',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+6.JPG',
		},
		{
			lat: '8.270533',
			lng: '124.60405',
			name: 'Purok 7',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+7.JPG',
		},
		{
			lat: '8.271067',
			lng: '124.60415',
			name: 'Purok 8',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+8.JPG',
		},
		{
			lat: '8.2708',
			lng: '124.604017',
			name: 'Purok 9',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+9.JPG',
		},
		{
			lat: '8.259233',
			lng: '124.616533',
			name: 'Purok 10',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+10.JPG',
		},
		{
			lat: '8.475933',
			lng: '124.6167',
			name: 'Purok 11',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+11.JPG',
		},
		{
			lat: '8.314133',
			lng: '124.601517',
			name: 'Purok 12',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+12.JPG',
		},
		{
			lat: '8.2592',
			lng: '124.6166',
			name: 'Purok 13',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+13.JPG',
		},
		{
			lat: '8.25875',
			lng: '124.616233',
			name: 'Purok 14',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+14.JPG',
		},
		{
			lat: '8.259017',
			lng: '124.616333',
			name: 'Purok 15',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+15.JPG',
		},
		{
			lat: '8.250167',
			lng: '124.632033',
			name: 'Purok 16',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+16.JPG',
		},
		{
			lat: '8.36355',
			lng: '124.610883',
			name: 'Purok 17',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+17.JPG',
		},
		{
			lat: '8.346567',
			lng: '124.609683',
			name: 'Purok 18',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Purok+18.JPG',
		},
		{
			lat: '12.673087',
			lng: '-1.585701',
			name: 'Tanlili 1',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tanlili+1.jpg',
		},
		{
			lat: '12.672988',
			lng: '-1.585738',
			name: 'Tanlili 2',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tanlili+2.jpg',
		},
		{
			lat: '12.673813',
			lng: '-1.586323',
			name: 'Tanlili 3',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tanlili+3.jpg',
		},
		{
			lat: '12.673805',
			lng: '-1.588164',
			name: 'Tanlili 4',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tanlili+4.jpg',
		},
		{
			lat: '12.671476',
			lng: '-1.588702',
			name: 'Tanlili 5',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tanlili+5.jpg',
		},
		{
			lat: '12.67239',
			lng: '-1.589019',
			name: 'Tanlili 6',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tanlili+6.jpg',
		},
		{
			lat: '12.672407',
			lng: '-1.592131',
			name: 'Tanlili 7',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tanlili+7.jpg',
		},
		{
			lat: '12.6728',
			lng: '-1.594605',
			name: 'Tanlili 8',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tanlili+8.jpg',
		},
		{
			lat: '12.67316',
			lng: '-1.594309',
			name: 'Tanlili 9',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tanlili+9.jpg',
		},
		{
			lat: '12.691983',
			lng: '-1.597926',
			name: 'Tanlili 10',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tanlili+10.jpg',
		},
		{
			lat: '12.695195',
			lng: '-1.596748',
			name: 'Tanlili 11',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tanlili+11.jpg',
		},
		{
			lat: '12.688265',
			lng: '-1.597476',
			name: 'Tanlili 12',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Tanlili+12.jpg',
		},
		{
			lat: '19.01881',
			lng: '-99.10496',
			name: 'SJT01',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT01.jpeg',
		},
		{
			lat: '19.02263',
			lng: '-99.09247',
			name: 'SJT02',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT02.jpeg',
		},
		{
			lat: '19.01543',
			lng: '-99.09271',
			name: 'SJT03',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT03.jpeg',
		},
		{
			lat: '19.02259',
			lng: '-99.09339',
			name: 'SJT04',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT04.jpeg',
		},
		{
			lat: '19.01816',
			lng: '-99.0938',
			name: 'SJT06',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT06.jpg',
		},
		{
			lat: '19.01477',
			lng: '-99.09099',
			name: 'SJT07',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT07.JPG',
		},
		{
			lat: '19.01667',
			lng: '-99.09988',
			name: 'SJT08',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT08.jpg',
		},
		{
			lat: '19.01543',
			lng: '-99.09271',
			name: 'SJT09',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT09.jpeg',
		},
		{
			lat: '19.0192',
			lng: '-99.09017',
			name: 'SJT10',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT10.HEIC',
		},
		{
			lat: '19.01667',
			lng: '-99.09988',
			name: 'SJT11',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT11.jpg',
		},
		{
			lat: '19.02039',
			lng: '-99.09954',
			name: 'SJT12',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT12.jpg',
		},
		{
			lat: '19.01342',
			lng: '-99.0929',
			name: 'SJT13',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT13.jpg',
		},
		{
			lat: '19.01487',
			lng: '-99.09281',
			name: 'SJT14',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT14.jpg',
		},
		{
			lat: '19.01406',
			lng: '-99.09355',
			name: 'SJT15',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT15.png',
		},
		{
			lat: '19.01689',
			lng: '-99.09521',
			name: 'SJT16',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT16.jpg',
		},
		{
			lat: '19.01697',
			lng: '-99.09431',
			name: 'SJT17',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT17.jpeg',
		},
		{
			lat: '19.01548',
			lng: '-99.09246',
			name: 'SJT18',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SJT18.jpeg',
		},
		{
			lat: '14.72374',
			lng: '-91.135991',
			name: 'SCP-1',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SCP-1.jpeg',
		},
		{
			lat: '14.72406',
			lng: '-91.134414',
			name: 'SCP-2',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SCP-2.jpg',
		},
		{
			lat: '14.72014',
			lng: '-91.132102',
			name: 'SCP-3',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SCP-3.jpg',
		},
		{
			lat: '14.72249',
			lng: '-91.134653',
			name: 'SCP-4',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SCP-4.JPG',
		},
		{
			lat: '14.72352',
			lng: '-91.134808',
			name: 'SCP-5',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SCP-5.JPG',
		},
		{
			lat: '14.72342',
			lng: '-91.135133',
			name: 'SCP-6',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SCP-6.JPG',
		},
		{
			lat: '14.72361',
			lng: '-91.136651',
			name: 'SCP-7',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SCP-7.JPG',
		},
		{
			lat: '14.72294',
			lng: '-91.129922',
			name: 'SCP-8',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SCP-8.jpg',
		},
		{
			lat: '14.72222',
			lng: '-91.132897',
			name: 'SCP-9',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SCP-9.jpg',
		},
		{
			lat: '14.72172',
			lng: '-91.133078',
			name: 'SCP-10',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/SCP-10.jpg',
		},
		{
			lat: '12.656711',
			lng: '-1.331999',
			name: '1000138251',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138251.jpg',
		},
		{
			lat: '12.63737442',
			lng: '-1.362509643',
			name: '1000138254',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138254.jpg',
		},
		{
			lat: '12.64013641',
			lng: '-1.361838491',
			name: '1000138257',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138257.jpg',
		},
		{
			lat: '12.64691487',
			lng: '-1.347002407',
			name: '1000138263',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138263.jpg',
		},
		{
			lat: '12.66024405',
			lng: '-1.358018722',
			name: '1000138266',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138266.jpg',
		},
		{
			lat: '12.64139558',
			lng: '-1.350545035',
			name: '1000138291',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138291.jpg',
		},
		{
			lat: '12.60534905',
			lng: '-1.254295071',
			name: '1000138341',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138341.jpg',
		},
		{
			lat: '12.62742469',
			lng: '-1.316495202',
			name: '1000138513',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138513.jpg',
		},
		{
			lat: '12.6271882',
			lng: '-1.334988477',
			name: '1000138516',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138516.jpg',
		},
		{
			lat: '12.58435231',
			lng: '-1.338274505',
			name: '1000138519',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138519.jpg',
		},
		{
			lat: '12.63057035',
			lng: '-1.333760787',
			name: '1000138522',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138522.jpg',
		},
		{
			lat: '12.63308799',
			lng: '-1.328727928',
			name: '1000138525',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138525.jpg',
		},
		{
			lat: '12.62759105',
			lng: '-1.317073992',
			name: '1000138528',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138528.jpg',
		},
		{
			lat: '12.6321655',
			lng: '-1.332986468',
			name: '1000138537',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138537.jpg',
		},
		{
			lat: '12.62732544',
			lng: '-1.313660895',
			name: '1000138540',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138540.jpg',
		},
		{
			lat: '12.60913162',
			lng: '-1.252171057',
			name: '1000138543',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138543.jpg',
		},
		{
			lat: '12.60961463',
			lng: '-1.254155736',
			name: '1000138546',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138546.jpg',
		},
		{
			lat: '12.60944636',
			lng: '-1.30665428',
			name: '1000138549',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138549.jpg',
		},
		{
			lat: '12.61833594',
			lng: '-1.249789246',
			name: '1000138552',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138552.jpg',
		},
		{
			lat: '12.60749026',
			lng: '-1.245850247',
			name: '1000138558',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138558.jpg',
		},
		{
			lat: '12.60748664',
			lng: '-1.245298068',
			name: '1000138561',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138561.jpg',
		},
		{
			lat: '12.60594351',
			lng: '-1.241562821',
			name: '1000138564',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138564.jpg',
		},
		{
			lat: '12.61458142',
			lng: '-1.239663149',
			name: '1000138567',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138567.jpg',
		},
		{
			lat: '12.61437122',
			lng: '-1.239314848',
			name: '1000138570',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138570.jpg',
		},
		{
			lat: '12.61800963',
			lng: '-1.240026274',
			name: '1000138579',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138579.jpg',
		},
		{
			lat: '12.61775303',
			lng: '-1.240865567',
			name: '1000138582',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138582.jpg',
		},
		{
			lat: '12.671133',
			lng: '-1.358878842',
			name: '1000138585',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138585.jpg',
		},
		{
			lat: '12.61760824',
			lng: '-1.244962219',
			name: '1000138591',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138591.jpg',
		},
		{
			lat: '12.61835328',
			lng: '-1.241422895',
			name: '1000138594',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138594.jpg',
		},
		{
			lat: '12.61818342',
			lng: '-1.241709372',
			name: '1000138597',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000138597.jpg',
		},
		{
			lat: '12.614976',
			lng: '-1.251625',
			name: '1000139089',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139089.jpg',
		},
		{
			lat: '12.63087071',
			lng: '-1.334090207',
			name: '1000139092',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139092.jpg',
		},
		{
			lat: '12.61969834',
			lng: '-1.246650681',
			name: '1000139095',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139095.jpg',
		},
		{
			lat: '12.6154785',
			lng: '-1.251005146',
			name: '1000139098',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139098.jpg',
		},
		{
			lat: '12.6208513',
			lng: '-1.793878203',
			name: '1000139101',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139101.jpg',
		},
		{
			lat: '12.6403559',
			lng: '-1.36225132',
			name: '1000139118',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139118.jpg',
		},
		{
			lat: '12.63697997',
			lng: '-1.363046042',
			name: '1000139129',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139129.jpg',
		},
		{
			lat: '12.64454583',
			lng: '-1.351270435',
			name: '1000139349',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139349.jpg',
		},
		{
			lat: '12.62771365',
			lng: '-1.31644729',
			name: '1000139361',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139361.jpg',
		},
		{
			lat: '12.62660109',
			lng: '-1.31347235',
			name: '1000139364',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139364.jpg',
		},
		{
			lat: '12.65019538',
			lng: '-1.315130989',
			name: '1000139373',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139373.jpg',
		},
		{
			lat: '12.67139576',
			lng: '-1.358978428',
			name: '1000139376',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139376.jpg',
		},
		{
			lat: '12.61430564',
			lng: '-1.237594223',
			name: '1000139699',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139699.jpg',
		},
		{
			lat: '12.66694871',
			lng: '-1.361980429',
			name: '1000139700',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139700.jpg',
		},
		{
			lat: '12.61336314',
			lng: '-1.250973491',
			name: '1000139701',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139701.jpg',
		},
		{
			lat: '12.57854509',
			lng: '-1.240056281',
			name: '1000139702',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139702.jpg',
		},
		{
			lat: '12.61466136',
			lng: '-1.238079581',
			name: '1000139703',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139703.jpg',
		},
		{
			lat: '12.61085252',
			lng: '-1.254082924',
			name: '1000139704',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139704.jpg',
		},
		{
			lat: '12.64126135',
			lng: '-1.362494089',
			name: '1000139767',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139767.jpg',
		},
		{
			lat: '12.64452793',
			lng: '-1.351298165',
			name: '1000139770',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/1000139770.jpg',
		},
		{
			lat: '11.928472',
			lng: '1.622528',
			name: '50-toilets-burkina-faso',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/50-toilets-burkina-faso.png',
		},
		{
			lat: '7.724722',
			lng: '124.299722',
			name: 'Butig1',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Butig1.jpg',
		},
		{
			lat: '7.724444',
			lng: '124.300278',
			name: 'Butig2',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Butig2.jpg',
		},
		{
			lat: '7.724444',
			lng: '124.299722',
			name: 'Butig3',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Butig3.jpg',
		},
		{
			lat: '7.724722',
			lng: '124.300278',
			name: 'Butig4',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Butig4.jpg',
		},
		{
			lat: '7.725278',
			lng: '124.300833',
			name: 'Butig5',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Butig5.jpg',
		},
		{
			lat: '7.724167',
			lng: '124.299167',
			name: 'Butig6',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Butig6.jpg',
		},
		{
			lat: '7.724722',
			lng: '124.3',
			name: 'Butig7',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Butig7.jpg',
		},
		{
			lat: '7.724722',
			lng: '124.3',
			name: 'Butig8',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Butig8.jpg',
		},
		{
			lat: '7.726389',
			lng: '124.313611',
			name: 'Butig9',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Butig9.jpg',
		},
		{
			lat: '7.723889',
			lng: '124.298333',
			name: 'Butig10',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Butig10.jpg',
		},
		{
			lat: '8.302',
			lng: '124.613',
			name: 'Langaon 2026-01',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon+2026-01.jpg',
		},
		{
			lat: '8.3033854',
			lng: '124.610621',
			name: 'Langaon 2026-02',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon+2026-02.jpg',
		},
		{
			lat: '8.298',
			lng: '124.628',
			name: 'Langaon 2026-03',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon+2026-03.jpg',
		},
		{
			lat: '8.294',
			lng: '124.602',
			name: 'Langaon 2026-04',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon+2026-04.jpg',
		},
		{
			lat: '8.298',
			lng: '124.605',
			name: 'Langaon 2026-05',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon+2026-05.jpg',
		},
		{
			lat: '8.298',
			lng: '124.606',
			name: 'Langaon 2026-06',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon+2026-06.jpg',
		},
		{
			lat: '8.297',
			lng: '124.604',
			name: 'Langaon 2026-07',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon+2026-07.jpg',
		},
		{
			lat: '8.297',
			lng: '124.601',
			name: 'Langaon 2026-08',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon+2026-08.jpg',
		},
		{
			lat: '8.298',
			lng: '124.607',
			name: 'Langaon 2026-09',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon+2026-09.jpg',
		},
		{
			lat: '8.301',
			lng: '124.61',
			name: 'Langaon 2026-10',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Langaon+2026-10.jpg',
		},
		{
			lat: '8.619',
			lng: '124.915',
			name: 'Claveria 01',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Claveria+01.png',
		},
		{
			lat: '8.618',
			lng: '124.915',
			name: 'Claveria 02',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Claveria+02.png',
		},
		{
			lat: '8.619',
			lng: '124.914',
			name: 'Claveria 03',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Claveria+03.png',
		},
		{
			lat: '8.619',
			lng: '124.913',
			name: 'Claveria 04',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Claveria+04.png',
		},
		{
			lat: '8.618',
			lng: '124.914',
			name: 'Claveria 05',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Claveria+05.png',
		},
		{
			lat: '8.619',
			lng: '124.916',
			name: 'Claveria 06',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Claveria+06.png',
		},
		{
			lat: '8.618',
			lng: '124.916',
			name: 'Claveria 07',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Claveria+07.png',
		},
		{
			lat: '8.619',
			lng: '124.9142',
			name: 'Claveria 08',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Claveria+08.png',
		},
		{
			lat: '8.619',
			lng: '124.908',
			name: 'Claveria 09',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Claveria+09.png',
		},
		{
			lat: '8.618',
			lng: '124.9152',
			name: 'Claveria 10',
			img_href: 'https://irp.cdn-website.com/0aecca97/dms3rep/multi/Claveria+10.png',
		},
	];